<template>
  <div class="ljzx-btn" @click="gotowx"> 咨询老师 </div>
</template>
<script>
import { qywx} from "@/utils/tool";
export default {
  methods: {
    gotowx(){
      window.location = qywx
    },
  }
}
</script>
<style scoped>
.ljzx-btn {
  width: 100%;
  height: .8rem;
  background: rgba(79, 217, 213, .1);
  border: 1px solid #4fd9d5;
  border-radius: .5rem;
  box-sizing: border-box;
  font-size: .26rem;
  font-weight: 400;
  color: #4fd9d5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  -webkit-border-radius: .5rem;
  -moz-border-radius: .5rem;
  -ms-border-radius: .5rem;
  -o-border-radius: .5rem;
  margin-top: .2rem;
}
</style>